module.exports = __webpack_public_path__ + "static/media/logo.fa5cb5f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.png
// module id = 5767
// module chunks = 0